import React, { useEffect, useRef, useState } from "react";
import API_URL from "../config/api";
import "./NatufHero.css";

const LandingPage = () => {
    const scrollRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("in-view");
                    }
                });
            },
            { threshold: 0.1 }
        );

        document.querySelectorAll(".reveal").forEach((el) => observer.observe(el));

        return () => observer.disconnect();
    }, []);

    // Scroll effect removed in favor of CSS animation
    // ... existing code ...
    const [formData, setFormData] = useState({
        name: "",
        phone: "",
        email: "",
        format: "",
        preferred_time: "",
    });

    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };



    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const response = await fetch(`${API_URL}/api/natuf`, {
                method: "POST", headers:
                {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                },
                body: JSON.stringify(formData),
            });

            const raw = await response.text();
            console.log("RAW RESPONSE:", raw);

            let data;
            try {
                data = JSON.parse(raw);
            } catch {
                throw new Error("Server returned invalid response");
            }

            if (!response.ok) {
                throw new Error(data.message || "Submission failed");
            }

            alert("Franchise enquiry submitted successfully");

            setFormData({
                name: "",
                phone: "",
                email: "",
                format: "",
                preferred_time: "",
            });

        } catch (err) {
            alert(err.message);
        } finally {
            setLoading(false);
        }
    };


    return (
        <div className="landing-wrapper">
            {/* Navbar */}
            <nav className="navbar">
                {/* Logo Section */}
                <a href="/" className="nav-brand">
                    <img
                        src="/assets/images/natuf-logo.png"
                        className="nav-logo"
                        alt="NATUF Logo"
                    />

                </a>

                {/* Hidden Checkbox - Must be before .nav-links */}

                <input type="checkbox" id="nav-toggle" style={{ display: 'none' }} />

                {/* Hamburger Button */}

                <label htmlFor="nav-toggle" className="nav-toggle">
                    <span></span>
                    <span></span>
                    <span></span>
                </label>
            </nav>
            {/* end */}



            {/* Hero Section */}
            <header className="hero" >
                <div className="hero-bg">
                    <div className="hero-content reveal reveal-up">
                        <h1 className="hero-brand">Middle Eastern<br/> Gourmet Made for<br/> Modern India</h1>

                        <p className="hero-description reveal reveal-up delay-200">
                            A premium Levantine food brand built for scalable <br />franchise growth across India.
                        </p>
                        <div className="hero-meta reveal reveal-up delay-400">
                            <p>
                                <span className="label">Formats:</span>
                                <span className="format cafe">Signature Café</span>
                                <span className="dot">•</span>
                                <span className="format flagship">Flagship Café</span>
                                <span className="dot">•</span>
                                <span className="format express">Express</span>
                                <span className="dot">•</span>
                                <span className="format kiosk">Kiosk</span>
                            </p>

                            <p>
                                <span className="label">Model:</span>
                                <span className="model foco">FOCO</span>

                            </p>

                            <p>
                                <span className="label">Backed by:</span>
                                <span className="backed">EBG Group</span>
                            </p>
                        </div>

                        <a href="#franchise-form" className="btn btn-gold animate-pulse reveal reveal-up delay-600">Apply for Franchise Opportunities</a>
                    </div>
                </div>
            </header>

            {/* end */}



            {/* Market Opportunity */}
            <section className="section market-opportunity-section" id="opportunity">
                <div className="market-opportunity-container">
                    <div className="market-opportunity-left reveal reveal-left">

                        {/* <span className="section-label">MARKET OPPORTUNITY</span> */}

                        <h2 className="market-opportunity-title">Why NATUF <br />Why Now</h2>
                        <div className="market-opportunity-image">
                            <img
                                src="/images/Image-1.png"
                                alt="Middle Eastern Food Spread"
                                className="opportunity-img animate-float"
                            />
                        </div>
                    </div>
                    <div className="market-opportunity-cards">
                        <div className="opportunity-card reveal reveal-right delay-100">
                            <p>Health-focused dining is now mainstream</p>
                        </div>
                        <div className="opportunity-card reveal reveal-right delay-200">
                            <p>Middle Eastern cuisine remains premium & under-penetrated</p>
                        </div>
                        <div className="opportunity-card reveal reveal-right delay-300">
                            <p>Tier 1 & Tier 2 cities are ready for aspirational brands</p>
                        </div>
                        <div className="opportunity-card reveal reveal-right delay-400">
                            <p>Consumers want experience + Quality + Trust</p>
                        </div>
                    </div>
                </div>
            </section>
            {/* end */}




            {/* What NATUF Offers */}
            <section
                className="section"
                id="offers"
                style={{
                    background: '#fff',
                    maxWidth: '100%',
                    fontFamily: 'fields, sans-serif'
                }}
            >
                <span className="section-label3" style={{ color: '#d1ab2a', fontWeight: '500', fontSize: '50px', justifyContent: "center", marginLeft: "35%", fontFamily: 'fields, sans-serif' }}>What Natuf Offers</span>
                <h2 className="section-title ">A Menu Designed for Scale</h2>
                <p className="text-center" style={{ marginBottom: '20px', opacity: 0.7, color: '#051e0f', marginTop: '-10px' }}>
                    A carefully curated portfolio of high-rotation, premium Middle Eastern offerings.
                </p>
                <div className="offers-grid">
                    {[
                        { title: "Hummus & Labneh", img: "/images/Natuf-01.jpg", desc: "Plant-protein dips with premium olive oil." },
                        { title: "Signature Falafel", img: "/images/Natuf-02.jpg", desc: "Ready-to-cook / serve artisan falafels." },
                        { title: "Authentic Tahini", img: "/images/Natuf-03.jpg", desc: "100% pure sesame paste, stone-ground." },
                        { title: "Pita & Chips", img: "/images/Natuf-04.jpg", desc: "Freshly baked bread & gourmet pita chips." },
                        { title: "Turkish Coffee", img: "/images/n1.png", desc: "Fine-ground, aromatic traditional coffee." },
                        { title: "Luxury Sweets", img: "/images/Natuf-06.jpg", desc: "Baklava, Mamool Cookies & Stuffed Dates." },
                        { title: "Hampers", img: "/images/Natuf-07.jpg", desc: "Luxury corporate gifting collections." },
                        { title: "Falafel Platter", img: "/images/n7.png", desc: "Served with Hummus, Salad & Pita." },
                        { title: "CAPPUCCINO", img: "/images/n9.png", desc: "Continental Hot Beverages" }
                    ].map((item, idx) => (
                        <div className={`card reveal reveal-scale delay-${(idx % 5 + 1) * 100}`} key={idx}>
                            <div className="card-img-wrapper">
                                <img src={item.img} alt={item.title} className="card-img" />
                            </div>
                            <div className="card-content">
                                <h3 className="offer-name">{item.title}</h3>
                                <p className="offer-desc">{item.desc}</p>
                            </div>
                        </div>
                    ))}
                </div>
                <div className="text-center" style={{ marginTop: '50px', }}>
                    <p className="uppercase" style={{ fontSize: '20px', fontWeight: 400, color: '#0e4725', fontFamily: 'fields, sans-serif' }}>Strong repeat consumption. High perceived value.</p>
                </div>
            </section>
            {/* end */}





            {/* Store & Format Options */}
            <section className="section" id="formats"  >
                <span className="section-label2">Store & Format Options</span>
                <h2 className="section-title2">Multiple Formats One Scalable Brand</h2>
                <div className="formats-grid" >
                    {[
                        {
                            name: "Signature Café",
                            img: "/images/signature-cafe.png",
                            investment: "₹1.25 Cr",
                            desc: "Premium high-street & flagship locations. Full dine-in experience.",
                            returns: ["2% MG on Invested Amount per month (or)  10% Gross Revenue per month", "Breakeven: 18 - 24 months"],
                            featured: true,
                            area: "800 - 1500 sq ft",
                            // best:"Prime Metro & Premium Retail Micro-Markets",
                            bgColor: "#0e4725",
                            borderColor: "#c8a24d"
                        },
                        {
                            name: "Flagship Café",
                            img: "/images/i2.jpeg",
                            investment: "₹85 L",
                            desc: "Large format for metro & Tier-1. Balanced dine-in + delivery.",
                            returns: ["2% MG on Invested Amount per month (or) 10% Gross Revenue per month", "Breakeven: 18 - 24 months"],
                            featured: true,
                            area: "500 - 800 sq ft",
                            // best:"Tier-1 & Tier-2 commercial zones, high street locations",
                            bgColor: "#0e4725",
                            borderColor: "#c8a24d"
                        },
                        {
                            name: "Express Café",
                            img: "/images/i1.jpeg",
                            investment: "₹55 L",
                            desc: "Prime retail. Scalable revenue. Strong visibility.",
                            // desc: "Compact model ideal for Tier-1 & Tier-2 cities.",
                            returns: ["2% MG on Invested Amount per month (or) 10% Gross Revenue per month", "Breakeven: 18 - 24 months"],
                            featured: true,
                            area: "200 - 500 sq ft",
                            best: " Tier-2, Tier-3 cities, office clusters, high-turnover zones",
                            bgColor: "#0e4725",
                            borderColor: "#c8a24d"
                        },
                        {
                            name: "Kiosk",
                            img: "/images/kiosk.png",
                            investment: "₹35 L",
                            desc: "Mall & transit-hub focused. High throughput, low footprint.",
                            returns: [
                                "2% MG on Invested Amount per month (or) 10% Gross Revenue per month",
                                "Breakeven: 18 - 24 months"
                            ],

                            featured: true,
                            area: "100 - 200 sq ft",
                            // best:"Malls, metro stations, campuses, high-impulse zones",
                            bgColor: "#0e4725",
                            borderColor: "#c8a24d"
                        }
                    ].map((format, idx) => (
                        <div
                            className={`format-card reveal reveal-up delay-${(idx + 1) * 100} ${format.featured ? 'featured' : ''}`}
                            key={idx}
                            style={{
                                backgroundColor: format.bgColor,
                                border: `4px solid ${format.borderColor}`
                            }}
                        >
                            <div className="format-img-wrapper">
                                <img src={format.img} alt={format.name} className="format-img" />
                            </div>
                            <div style={{ padding: '30px' }}>
                                <span className="format-investment-label">INVESTMENT</span>
                                <h3 className="format-title">{format.name}</h3>
                                <span className="investment">{format.investment}</span>
                                <p className="format-desc">{format.desc}</p>
                                {/* <p className="format-best">{format.best}</p> */}
                                <p className="format-area">Area: {format.area}</p>
                                <div className="returns-box">
                                    <span className="returns-title">Indicative Returns</span>
                                    <ul className="returns-list">
                                        {format.returns.map((r, i) => (
                                            <li key={i}>
                                                {r.split("OR").map((part, index, arr) => (
                                                    <React.Fragment key={index}>
                                                        {part.trim()}
                                                        {index !== arr.length - 1 && (
                                                            <>
                                                                <br />
                                                                or
                                                                <br />
                                                            </>
                                                        )}
                                                    </React.Fragment>
                                                ))}
                                            </li>
                                        ))}
                                    </ul>


                                </div>
                            </div>
                        </div>
                    ))}
                </div>

            </section>
            {/* end */}



            {/* Franchise Models */}
            <section className="section" id="franchise" style={{ background: '#fff' }}>
                <span className="section-label text-center reveal reveal-up"
                    style={{ color: '#d1ab2a', fontWeight: '500', fontSize: '50px', justifyContent: "center", marginLeft: "-10px", marginBottom: '-10px', marginTop: '10px', fontFamily: 'fields, sans-serif' }}>Franchise Models</span>
                <h2 className="section-title text-center reveal reveal-up delay-200">Flexible Partner Models</h2>
                <div className="models-grid reveal reveal-scale delay-400">
                    <div className="model-card">
                        <h3>FOCO</h3>
                        <p className="uppercase" style={{ fontSize: '15px', color: '#c8a24d', marginBottom: '20px', letterSpacing: '2px', fontfamily: 'Mulish'}}>Franchise Owned  Company Operated</p>
                        <div className="model-features">
                            <ul className="model-list">
                                <li>
                                    <span className="check-icon">✓</span>
                                    <span>Professional management by NATUF team</span>
                                </li>
                                <li>
                                    <span className="check-icon">✓</span>
                                    <span>Central control for consistency</span>
                                </li>
                                <li>
                                    <span className="check-icon">✓</span>
                                    <span>Ideal for passive investors</span>
                                </li>
                            </ul>
                            <div className="model-return">
                                <span className="return-label">RETURN:</span>
                                <span className="return-value">2% MG on Invested Amount per month <span style={{ color: '#d1ab2a' }}>(or)</span>10% Gross Revenue per month</span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* end */}




            {/* Why invest */}
            <section className="invest2" id="advantages">
                <div className="reveal reveal-up container">
                    <span className="section-label reveal reveal-up delay-100" style={{ color: '#d1ab2a', fontWeight: '500', fontSize: '50px', justifyContent: "center", marginLeft: "-10px", marginBottom: '-10px', marginTop: '-30px', fontFamily: 'fields, sans-serif' }}>Advantages</span>
                    <h2 className="section-title reveal reveal-up delay-200">The NATUF Advantage</h2>

                    <div className="advantages-grid">
                        {[
                            { title: "Backed by EBG Group", icon: "fa-building-shield" },
                            { title: "Proven multi-format scalability", icon: "fa-chart-line" },
                            { title: "Centralized sourcing & supply chain", icon: "fa-truck-fast" },
                            { title: "Live ERP, CCTV & audit systems", icon: "fa-display" },
                            { title: "Co-funded marketing support", icon: "fa-bullhorn" },
                            { title: "Structured onboarding & launch", icon: "fa-rocket" }
                        ].map((item, idx) => (
                            <div className={`advantage-card reveal reveal-up delay-${(idx + 1) * 100}`} key={idx}>
                                <div className="advantage-icon">
                                    <i className={`fa-solid ${item.icon}`}></i>
                                </div>
                                <h3 className="advantage-text">{item.title}</h3>
                            </div>
                        ))}
                    </div>

                    <div className="invest-footer reveal reveal-up delay-800">
                        <p className="text-olive">
                            You focus on growth. <strong>We handle the systems.</strong>
                        </p>
                    </div>
                </div>
            </section>
            {/* end */}






            {/* Café Experience Section */}

            <section className="experience-section reveal reveal-up">
                <div className="experience-bg">
                    <img src="/images/Banner.png" alt="Natuf Experience" className="reveal reveal-scale delay-200" />
                    <div className="experience-overlay"></div>
                </div>

                <div className="experience-content reveal reveal-up delay-400">
                    <h2 className="section-title experience-title">
                        The Natuf<br />Experience
                    </h2>

                    <p className="experience-text">
                        From our curated music to our bespoke interiors, every detail is designed
                        to transport you to the sun soaked shores of the Mediterranean.
                    </p>
                </div>
            </section>
            {/* end */}


            {/* Investor Profile */}
            <section className="investor-profile reveal reveal-up">
                <div className="eyebrow reveal reveal-up delay-100">Natuf Franchise</div>
                <h1 className="reveal reveal-up delay-200">Ideal Investor Profile</h1>
                <div className="divider reveal reveal-scale delay-300"></div>

                <div className="investor-track-container">
                    <div className="investor-track">
                        {[
                            { icon: "fa-briefcase", label: "Business Owners & Entrepreneurs" },
                            { icon: "fa-coins", label: "HNI & Family Office Investors" },
                            { icon: "fa-hotel", label: "Hospitality Professionals" },
                            { icon: "fa-store", label: "Retail & F&B Operators" },
                            { icon: "fa-building", label: "Corporate Groups Looking to Diversify" },
                            { icon: "fa-briefcase", label: "Business Owners & Entrepreneurs" },
                            { icon: "fa-coins", label: "HNI & Family Office Investors" },
                            { icon: "fa-hotel", label: "Hospitality Professionals" },
                            { icon: "fa-store", label: "Retail & F&B Operators" },
                            { icon: "fa-building", label: "Corporate Groups Looking to Diversify" }
                        ].map((item, idx) => (
                            <div className={`investor-card reveal reveal-up delay-${(idx % 5 + 1) * 100}`} key={idx}>
                                <div className="icon">
                                    <i className={`fa-solid ${item.icon}`}></i>
                                </div>
                                <h3 style={{ fontSize: '18px', color: '#333', marginTop: '15px' }}>{item.label}</h3>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="highlight reveal reveal-up delay-500">
                    If you believe in premium brands with long-term potential, NATUF fits.
                </div>
            </section>
            {/* end */}



            {/* Lead Capture */}

            <section className="journey-section reveal reveal-up" id="contact">
                <div className="journey-header">
                    <h2 className="reveal reveal-up delay-100">Start Your <span className="gold-text">NATUF</span> Franchise Journey</h2>
                    <p className="reveal reveal-up delay-200">Get everything you need to evaluate, invest, and launch with confidence.</p>
                </div>

                <div className="journey-grid">
                    {[
                        { icon: "fa-file-lines", title: "Detailed Franchise Deck", desc: "Brand vision, financials, rollout plan & growth strategy", type: "regular" },
                        { icon: "fa-store", title: "Investment Models & Store Formats", desc: "Flagship, Café, Express & Kiosk formats explained", type: "solid" },
                        { icon: "fa-map-location-dot", title: "City-wise Opportunity Mapping", desc: "Territory analysis & expansion roadmap", type: "solid" },
                        { icon: "fa-utensils", title: "Product Catalogue & Sampling Plan", desc: "Menu range, sourcing & tasting experience", type: "solid" }
                    ].map((card, idx) => (
                        <div className={`journey-card reveal reveal-up delay-${(idx + 1) * 100}`} key={idx}>
                            <div className="journey-icon"><i className={`fa-${card.type} ${card.icon}`}></i></div>
                            <h3>{card.title}</h3>
                            <p>{card.desc}</p>
                        </div>
                    ))}
                </div>
            </section>

            {/* end */}



            {/* form */}
            <section className="section dark reveal reveal-up" id="franchise-form">
                <div className="container form-grid">
                    <div className="reveal reveal-left delay-200">
                        <h2>Start Your NATUF Franchise Journey</h2>
                        <ul>
                            <li className="reveal reveal-left delay-300">Detailed Franchise Deck</li>
                            <li className="reveal reveal-left delay-400">Investment Models</li>
                            <li className="reveal reveal-left delay-500">City-wise Opportunity Mapping</li>
                            <li className="reveal reveal-left delay-600">Product Catalogue</li>
                        </ul>
                    </div>

                    <form className="form-card reveal reveal-right delay-200" onSubmit={handleSubmit}>

                        <input
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            placeholder="Full Name"
                            required
                            className="reveal reveal-up delay-300" 
                        />

                        <input
                            name="phone"
                            value={formData.phone}
                            onChange={handleChange}
                            placeholder="Phone Number"
                            required
                            className="reveal reveal-up delay-400"
                        />

                        <input
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            placeholder="Email"
                            type="email"
                            required
                            className="reveal reveal-up delay-500"
                        />


                        <select
                            name="format"
                            value={formData.format}
                            onChange={handleChange}
                            required
                            className="reveal reveal-up delay-600"
                        >
                            <option value="">Preferred Franchise Format</option>
                            <option value="Signature Café">Signature Café</option>
                            <option value="Express Café">Express Café</option>
                            <option value="Kiosk">Kiosk</option>
                            <option value="Flagship Café">Flagship Café</option>

                        </select>

                        <select
                            name="preferred_time"
                            value={formData.preferred_time}
                            onChange={handleChange}
                            required
                            className="reveal reveal-up delay-700"
                        >
                            <option value="">Preferred Time for call</option>
                            <option value="10 AM-12 PM">10 AM-12 PM</option>
                            <option value="12 PM-2 PM">12 PM-2 PM</option>
                            <option value="2 PM-4 PM">2 PM-4 PM</option>
                            <option value="4 PM-6 PM">4 PM-6 PM</option>
                            <option value="Saturday">Saturday</option>
                            <option value="Sunday">Sunday</option>
                        </select>




                        <button className="btn-primary animate-pulse reveal reveal-up delay-800" disabled={loading}>
                            {loading ? "Submitting..." : "Apply for Franchise"}
                        </button>

                    </form>
                </div>
            </section>
            {/* end */}



            {/* Footer */}
            <footer className="footer" id="footer">
                <div className="footer-content">

                    {/* Brand Section (Left) */}
                    <div className="footer-left">
                        <img
                            src="/images/logo.png"
                            alt="NATUF Logo"
                            className="footer-logo"
                        />
                        <p className="footer-tagline">
                            Building India’s premium Middle Eastern food category.
                        </p>
                    </div>

                    {/* Copyright (Center) */}
                    <div className="footer-center">
                        <p>© NATUF by EBG Group - All Rights Reserved</p>
                    </div>

                    {/* Social Section (Right) */}

                    <div className="social-icons">
                        <a href="https://www.instagram.com/natuf.india/" aria-label="Instagram">
                            <img src="/images/instagram1.png" alt="Instagram" />
                        </a>

                        <a href="https://snapchat.com/t/eYNifPHs" aria-label="Facebook">
                            <img src="/images/facebook1.png" alt="Facebook" />
                        </a>

                        <a href="https://www.youtube.com/@tasteofNatuf" aria-label="YouTube">
                            <img src="/images/youtube1.png" alt="YouTube" />
                        </a>

                        <a href="https://www.facebook.com/NatufIndia" aria-label="Snapchat">
                            <img src="/images/snapchat1.png" alt="Snapchat" />
                        </a>
                    </div>
                </div>

            </footer >
            {/* end */}


        </div >
    );
};

export default LandingPage;
